import Temp from '@/courier/Temp'

export default class SCGFrozen extends Temp {

    static CODE = 'SCGF';

    constructor() {
        super( SCGFrozen.CODE ); 
    }

    getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0

        remote_area = super.checkRemoteArea( Number(item.toPostcode) );
        
        from = super.checkZone( Number(item.fromPostcode))
        to = super.checkZone( item.toPostcode )
        if ( (from == 1 && to == 1) || ( item.fromPostcode.toString().substring( 0 , 2 ) == item.toPostcode.toString().substring( 0 , 2 ) ) ) {
            type = 1;
        }else{
            if( from == 1 ){
                type = 2
            }else{
                type = 3
            }
        }

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates, item ){
        item.index = courierRates.findIndex(rate => {
            return rate.dimension == item.keySize
        })

        return {
            index: item.index
          }
    }

    async checkRemoteAreaByCorrectorDest( addressRemote ){
        return new Promise(resolve => {
          super.getRemoteArea( addressRemote ).then( res => {
            if( res.status === 1 && ((res.data).hasOwnProperty('isRemote') 
                || (res.data).hasOwnProperty('isRemote100') )
                && res.data.isRemote.includes('scg') 
                || ( (res.data).hasOwnProperty('isIsland') && res.data.isIsland.includes('scg') )
            ){
              resolve( true );
            }else if( res.status === 0 && res.data.length === 0 ){
              resolve( true );
            }else{
              resolve( false );
            }
          }) 
        })
    }

}